/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductPreferenceFragment = { __typename: 'PimProductPreference', scope: Types.PimProductPreferenceScope, createdAt: any, productType: { __typename: 'PimProductPreferenceProductType', productTypeSystemKey: string, productTypeKey: string }, articleNumberIdentifier: { __typename: 'PimProductPreferenceArticleNumberIdentifier', supplierId: string, articleNumber: string } };

export type AddProductPreferenceResultFragment = { __typename: 'PimAddProductPreferenceResult', status: Types.PimAddProductPreferenceStatus, articleNumberIdentifier: { __typename: 'PimProductPreferenceArticleNumberIdentifier', supplierId: string, articleNumber: string }, conflictingProductType?: { __typename: 'PimConflictingProductType', productTypeSystemKey: string, productTypeKey: string, source: Types.PimProductTypeClassificationSource, label?: string | null } | null };

export type ProductPreferencesQueryVariables = Types.Exact<{
  productType?: Types.InputMaybe<Types.PimProductTypeRefInput>;
}>;


export type ProductPreferencesQuery = { pimProductPreferences: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimProductPreferencesResult', preferences: Array<{ __typename: 'PimProductPreference', scope: Types.PimProductPreferenceScope, createdAt: any, productType: { __typename: 'PimProductPreferenceProductType', productTypeSystemKey: string, productTypeKey: string }, articleNumberIdentifier: { __typename: 'PimProductPreferenceArticleNumberIdentifier', supplierId: string, articleNumber: string } }> } };

export type AddProductPreferencesMutationVariables = Types.Exact<{
  input: Types.PimAddProductPreferencesInput;
}>;


export type AddProductPreferencesMutation = { pimAddProductPreferences: { __typename: 'PimAddProductPreferencesResult', results: Array<{ __typename: 'PimAddProductPreferenceResult', status: Types.PimAddProductPreferenceStatus, articleNumberIdentifier: { __typename: 'PimProductPreferenceArticleNumberIdentifier', supplierId: string, articleNumber: string }, conflictingProductType?: { __typename: 'PimConflictingProductType', productTypeSystemKey: string, productTypeKey: string, source: Types.PimProductTypeClassificationSource, label?: string | null } | null }> } };

export type DeleteProductPreferencesMutationVariables = Types.Exact<{
  input: Types.PimDeleteProductPreferencesInput;
}>;


export type DeleteProductPreferencesMutation = { pimDeleteProductPreferences: { __typename: 'PimDeleteProductPreferencesResult', ok: boolean } };

export const ProductPreferenceFragmentDoc = gql`
    fragment ProductPreference on PimProductPreference {
  scope
  productType {
    productTypeSystemKey
    productTypeKey
  }
  articleNumberIdentifier {
    supplierId
    articleNumber
  }
  createdAt
}
    `;
export const AddProductPreferenceResultFragmentDoc = gql`
    fragment AddProductPreferenceResult on PimAddProductPreferenceResult {
  articleNumberIdentifier {
    supplierId
    articleNumber
  }
  status
  conflictingProductType {
    productTypeSystemKey
    productTypeKey
    source
    label
  }
}
    `;
export const ProductPreferencesDocument = gql`
    query ProductPreferences($productType: PimProductTypeRefInput) {
  pimProductPreferences(productType: $productType) {
    ... on PimProductPreferencesResult {
      preferences {
        ...ProductPreference
      }
    }
  }
}
    ${ProductPreferenceFragmentDoc}`;

/**
 * __useProductPreferencesQuery__
 *
 * To run a query within a React component, call `useProductPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPreferencesQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useProductPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<ProductPreferencesQuery, ProductPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPreferencesQuery, ProductPreferencesQueryVariables>(ProductPreferencesDocument, options);
      }
export function useProductPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPreferencesQuery, ProductPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPreferencesQuery, ProductPreferencesQueryVariables>(ProductPreferencesDocument, options);
        }
export function useProductPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPreferencesQuery, ProductPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPreferencesQuery, ProductPreferencesQueryVariables>(ProductPreferencesDocument, options);
        }
export type ProductPreferencesQueryHookResult = ReturnType<typeof useProductPreferencesQuery>;
export type ProductPreferencesLazyQueryHookResult = ReturnType<typeof useProductPreferencesLazyQuery>;
export type ProductPreferencesSuspenseQueryHookResult = ReturnType<typeof useProductPreferencesSuspenseQuery>;
export type ProductPreferencesQueryResult = Apollo.QueryResult<ProductPreferencesQuery, ProductPreferencesQueryVariables>;
export const AddProductPreferencesDocument = gql`
    mutation AddProductPreferences($input: PimAddProductPreferencesInput!) {
  pimAddProductPreferences(input: $input) {
    results {
      ...AddProductPreferenceResult
    }
  }
}
    ${AddProductPreferenceResultFragmentDoc}`;
export type AddProductPreferencesMutationFn = Apollo.MutationFunction<AddProductPreferencesMutation, AddProductPreferencesMutationVariables>;

/**
 * __useAddProductPreferencesMutation__
 *
 * To run a mutation, you first call `useAddProductPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductPreferencesMutation, { data, loading, error }] = useAddProductPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<AddProductPreferencesMutation, AddProductPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductPreferencesMutation, AddProductPreferencesMutationVariables>(AddProductPreferencesDocument, options);
      }
export type AddProductPreferencesMutationHookResult = ReturnType<typeof useAddProductPreferencesMutation>;
export type AddProductPreferencesMutationResult = Apollo.MutationResult<AddProductPreferencesMutation>;
export type AddProductPreferencesMutationOptions = Apollo.BaseMutationOptions<AddProductPreferencesMutation, AddProductPreferencesMutationVariables>;
export const DeleteProductPreferencesDocument = gql`
    mutation DeleteProductPreferences($input: PimDeleteProductPreferencesInput!) {
  pimDeleteProductPreferences(input: $input) {
    ok
  }
}
    `;
export type DeleteProductPreferencesMutationFn = Apollo.MutationFunction<DeleteProductPreferencesMutation, DeleteProductPreferencesMutationVariables>;

/**
 * __useDeleteProductPreferencesMutation__
 *
 * To run a mutation, you first call `useDeleteProductPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductPreferencesMutation, { data, loading, error }] = useDeleteProductPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductPreferencesMutation, DeleteProductPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductPreferencesMutation, DeleteProductPreferencesMutationVariables>(DeleteProductPreferencesDocument, options);
      }
export type DeleteProductPreferencesMutationHookResult = ReturnType<typeof useDeleteProductPreferencesMutation>;
export type DeleteProductPreferencesMutationResult = Apollo.MutationResult<DeleteProductPreferencesMutation>;
export type DeleteProductPreferencesMutationOptions = Apollo.BaseMutationOptions<DeleteProductPreferencesMutation, DeleteProductPreferencesMutationVariables>;